module.exports = __webpack_public_path__ + "static/img/cloud-main.147d3ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/gtn/assets/developerConference/cloud-main.png
// module id = m4/R
// module chunks = 86